var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileHeadset({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46005 18.99V16.07C5.46005 15.1 6.22005 14.23 7.30005 14.23C8.27005 14.23 9.14005 14.99 9.14005 16.07V18.88C9.14005 20.83 7.52005 22.4501 5.57005 22.4501C3.62005 22.4501 2.00005 20.82 2.00005 18.88V12.72C1.89005 7.10005 6.33005 2.55005 11.95 2.55005C17.57 2.55005 22 7.10005 22 12.61V18.7701C22 20.7201 20.38 22.34 18.43 22.34C16.48 22.34 14.86 20.7201 14.86 18.7701V15.96C14.86 14.99 15.62 14.12 16.7 14.12C17.67 14.12 18.54 14.88 18.54 15.96V18.99",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileHeadset);
export default __webpack_public_path__ + "static/media/file-headset.695304844efd0684206e0bd518ef1eb1.svg";
export { ForwardRef as ReactComponent };